"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultFormatter = void 0;
var React = require("react");
var DefaultFormatter = function (props) {
    return React.createElement("div", { children: props.value, "data-tb-test-id": props.testId });
};
exports.DefaultFormatter = DefaultFormatter;
exports.DefaultFormatter.displayName = 'DataGridDefaultFormatter';
//# sourceMappingURL=DefaultFormatter.js.map